import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import { BsCheck2 } from "react-icons/bs";
import "./errorModal.css";

function ErrorModal(props: any) {
  const navigate = useNavigate();

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      centered
      className="pricing-modal"
    >
      <Modal.Body className="p-0">
        <div className="modal-grid">
          <div className="modal-left">
            <div className="logo-section">
              <div className="app-logo">QRSharp</div>
            </div>
            <h2>Unlock Analytics Features</h2>
            <p className="description">
              You are currently using our Free Plan. Upgrade to our Premium Plan
              to unlock detailed analytics and tracking features. It's risk-free
              with a 14-day money-back guarantee.
            </p>
            <div className="button-group">
              <Button
                variant="link"
                onClick={props.onHide}
                className="cancel-btn"
              >
                Maybe Later
              </Button>
              <Button
                onClick={() => navigate("/dashboard/plans")}
                className="upgrade-btn"
              >
                Upgrade Plan
              </Button>
            </div>
          </div>
          <div className="modal-right">
            <div className="features-section">
              <h6>Included with the pro plan</h6>
              <ul className="features-list">
                <li>
                  <BsCheck2 /> Visit Tracking with Analytics
                </li>
                <li>
                  <BsCheck2 /> Detailed Geographic Data
                </li>
                <li>
                  <BsCheck2 /> Device & Browser Analytics
                </li>
                <li>
                  <BsCheck2 /> Unlimited QR Codes
                </li>
                <li>
                  <BsCheck2 /> Priority Support
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ErrorModal;
